<template>
    <validation-observer v-slot="{ invalid, handleSubmit }" ref="userValidator" v-if="!loading">
        <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

            <base-input class="mb-3"
                :label="$t('common.username')"
                label-classes="form-control-label required"
                :placeholder="$t('common.username')"
                v-model="value.username"
                name="username"
                rules="required"
                :disabled="!fullRights && !pilotRights"
                :error="errors.get('username')"
            >
            </base-input>

            <base-input class="mb-3"
                :label="$t('users.lastname')"
                label-classes="form-control-label required"
                :placeholder="$t('users.lastname')"
                v-model="value.lastname"
                name="lastname"
                rules="required"
                :disabled="!fullRights && !pilotRights"
                :error="errors.get('lastname')"
            >
            </base-input>

            <base-input class="mb-3"
                :label="$t('users.firstname')"
                label-classes="form-control-label required"
                :placeholder="$t('users.firstname')"
                v-model="value.firstname"
                name="firstname"
                rules="required"
                :disabled="!fullRights && !pilotRights"
                :error="errors.get('firstname')"
            >
            </base-input>

            <base-input class="mb-3"
                type="email"
                :label="$t('common.email')"
                label-classes="form-control-label required"
                :placeholder="$t('common.email')"
                v-model="value.email"
                name="email"
                rules="required|email"
                :disabled="!fullRights && !pilotRights"
                :error="errors.get('email')"
            >
            </base-input>

            <base-select class="mb-4" v-if="$auth.user.id !== value.id"
                :label="$t('common.role')"
                :placeholder="$t('common.role')"
                v-model="value.role_id"
                :options="roles"
                clearable
            >
            </base-select>

            <base-select class="mb-4" v-if="Object.keys(entities).length > 0 && !pilotRights"
                :label="$t('common.client')"
                placeholder="ICAO code"
                v-model="value.entity_id"
                :options="entities"
                :filterable="true"
                :scroll="true"
                clearable
            >
            </base-select>

            <base-select class="mb-4" v-if="!$auth.user.owner_id && $auth.user.id !== value.id && !pilotRights"
                :label="$t('common.owner')"
                :placeholder="$t('common.owner')"
                v-model="value.owner_id"
                :options="owners"
                :disabled="!fullRights"
                clearable
            >
            </base-select>

            <base-input class="mb-3"
                :label="$t('users.enac-id')"
                :placeholder="$t('users.enac-id')"
                v-model="value.enac_id"
                name="enac_id"
                :error="errors.get('enac_id')"
                v-if="fullRights && $auth.user.id !== value.id"
            >
            </base-input>

            <base-select class="mb-4" v-if="fullRights && $auth.user.id !== value.id"
                :label="$t('common.source')"
                :placeholder="$t('common.source')"
                v-model="value.source"
                :options="sources"
            >
            </base-select>

            <base-switch class="mb-3"
                v-model="value.active"
                :label="$t('common.active')"
                v-if="$auth.user.id !== value.id"
            ></base-switch>

            <div class="category form-category mb-4">
                <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
            </div>

            <div class="text-center">
                <base-button native-type="submit"
                    type="primary"
                    :disabled="errors.any() || invalid"
                    :loading="recording"
                >
                    {{ value.id ? $t('common.update') : $t('common.create') }}
                </base-button>

                <base-button type="link" class="ml-auto"
                    v-if="modal"
                    @click="modal.show = false"
                >
                    {{ $t('common.cancel') }}
                </base-button>
            </div>

        </form>
    </validation-observer>
</template>

<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true
            },
            errors: {
                type: Object,
                required: true
            },
            modal: {
                type: Object,
                default: null
            },
            roles: {
                type: Object,
                required: true
            },
            owners: {
                type: Object,
                required: true
            },
            entities: {
                type: Object,
                required: true
            },
            loading: {
                type: Boolean,
                default: false
            },
            recording: {
                type: Boolean,
                default: false
            },
        },

        computed: {

            fullRights() {
                return this.$auth.hasPermission('user.manage')
            },

            pilotRights() {
                return !this.fullRights && this.$auth.hasPermission('user.manage-pilots')
            },

            sources() {
                return {
                    internal: this.$t('users.internal'),
                    ldap: this.$t('users.ldap'),
                    ldap2: this.$t('users.ldap2'),
                }
            }
        },

        created() {
            this.errors.setValidator('userValidator', this)
        },

        methods: {
            
            submit() {
                this.$emit('input', { ...this.value})
            }
        }
    }
</script>
